export default "__VITE_ASSET__CTFpPR6K__"